import { v4 as uuidv4 } from 'uuid';
import { addCommas, digitsFaToEn } from 'persian-tools2';
import {jwtDecode} from 'jwt-decode';

export function checkPersian(str) {
  const p = /[\u0600-\u06FF\s]+/;

  return p.test(str.replace(' ', ''));
}

export function addUniqueKey(array) {
  return array?.map((item) => {
    return { __id: uuidv4(), ...item };
  });
}

/**
 * convert a flat list of nodes into tree array
 * @param array list of nodes as flat array
 * @param parentChildData data to locate node parents
 */
export function listToTree(array, parentChildData) {
  let root = [];
  array.forEach((el) => {
    // Use our mapping to locate the parent element in our data array
    const parent = parentChildData(el, array);

    if (!parent) {
      root.push(el);
      return;
    }
    // Add our current el to its parent's `children` array
    parent.children = [...(parent.children || []), el];
  });

  return root;
}

export function normalizeArray(array) {
  return array.filter(Boolean);
}

export function textToMaterialColor(theme, text, returnParent = false) {
  const palette = theme.palette
  if (!text) return palette.text.primary;

  const hasDot = text.indexOf('.') !== -1;
  if (hasDot) {
    const color = text.split('.');
    return returnParent ? palette[color[0]] : palette[color[0]][color[1]];
  } else return !returnParent ? palette[text].main : palette[text];
}

export function toFarsiNumber(n, useComma = false) {
  const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const text = useComma ? addCommas(n) : n;
  const result = text?.toString().replace(/\d/g, (x) => farsiDigits[x]);
  return result;
}

export function toNationalCode(phone) {
  const enNumber = digitsFaToEn(phone);
  const result = enNumber?.toString().replace(/^0+/, '').replace(/^98+/, '');
  return `0${result}`;
}

export function isEmpty(obj) {
  return obj === undefined || null ? true : Object.keys(obj).length === 0;
}

export function arrayUniqueKey(array, key) {
  return [...new Map(array.map((item) => [item[key], item])).values()];
}


export function getComputedValue(value, percentage) {
  return `${(value * percentage) / 100}px`;
}



export function isBase64Url(str){
  const base64urlRegex = /^[A-Za-z0-9-_]+$/;
  return base64urlRegex.test(str);
};

export function isValidJwtStructure(token){
  if (typeof token !== 'string') return false;
  
  const parts = token.split('.');
  if (parts.length !== 3) return false;

  return parts.every(isBase64Url);
};

export function isTokenExpired(token){
  if (!token || !isValidJwtStructure(token)) return true;

  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000; // convert to seconds

    return decodedToken.exp < currentTime;
  } catch (error) {
    // If decoding fails, consider the token as expired
    return true;
  }
};